/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as DocsRouteRouteImport } from './routes/docs/route'
import { Route as PlaygroundRouteImport } from './routes/playground'
import { Route as DocsIndexRouteImport } from './routes/docs/index'
import { Route as DocsApiIndexRouteImport } from './routes/docs/api/index'
import { Route as DocsBenchmarksIndexRouteImport } from './routes/docs/benchmarks/index'
import { Route as DocsGuidesIndexRouteImport } from './routes/docs/guides/index'
import { Route as DocsGuidesInstallationRouteImport } from './routes/docs/guides/installation'
import { Route as DocsGuidesInteractiveModeRouteImport } from './routes/docs/guides/interactive-mode'
import { Route as DocsGuidesQuickStartRouteImport } from './routes/docs/guides/quick-start'
import { Route as DocsApiArrayMethodsIndexRouteImport } from './routes/docs/api/array-methods/index'
import { Route as DocsApiBuiltinsIndexRouteImport } from './routes/docs/api/builtins/index'
import { Route as DocsApiFormatsIndexRouteImport } from './routes/docs/api/formats/index'
import { Route as DocsApiShortcutsIndexRouteImport } from './routes/docs/api/shortcuts/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsRouteRoute = DocsRouteRouteImport.update({
  id: '/docs',
  path: '/docs',
  getParentRoute: () => rootRouteImport,
} as any)
const PlaygroundRoute = PlaygroundRouteImport.update({
  id: '/playground',
  path: '/playground',
  getParentRoute: () => rootRouteImport,
} as any)
const DocsIndexRoute = DocsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsApiIndexRoute = DocsApiIndexRouteImport.update({
  id: '/api/',
  path: '/api/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsBenchmarksIndexRoute = DocsBenchmarksIndexRouteImport.update({
  id: '/benchmarks/',
  path: '/benchmarks/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsGuidesIndexRoute = DocsGuidesIndexRouteImport.update({
  id: '/guides/',
  path: '/guides/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsGuidesInstallationRoute = DocsGuidesInstallationRouteImport.update({
  id: '/guides/installation',
  path: '/guides/installation',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsGuidesInteractiveModeRoute =
  DocsGuidesInteractiveModeRouteImport.update({
    id: '/guides/interactive-mode',
    path: '/guides/interactive-mode',
    getParentRoute: () => DocsRouteRoute,
  } as any)
const DocsGuidesQuickStartRoute = DocsGuidesQuickStartRouteImport.update({
  id: '/guides/quick-start',
  path: '/guides/quick-start',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsApiArrayMethodsIndexRoute =
  DocsApiArrayMethodsIndexRouteImport.update({
    id: '/api/array-methods/',
    path: '/api/array-methods/',
    getParentRoute: () => DocsRouteRoute,
  } as any)
const DocsApiBuiltinsIndexRoute = DocsApiBuiltinsIndexRouteImport.update({
  id: '/api/builtins/',
  path: '/api/builtins/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsApiFormatsIndexRoute = DocsApiFormatsIndexRouteImport.update({
  id: '/api/formats/',
  path: '/api/formats/',
  getParentRoute: () => DocsRouteRoute,
} as any)
const DocsApiShortcutsIndexRoute = DocsApiShortcutsIndexRouteImport.update({
  id: '/api/shortcuts/',
  path: '/api/shortcuts/',
  getParentRoute: () => DocsRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/docs': typeof DocsRouteRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/docs/': typeof DocsIndexRoute
  '/docs/guides/installation': typeof DocsGuidesInstallationRoute
  '/docs/guides/interactive-mode': typeof DocsGuidesInteractiveModeRoute
  '/docs/guides/quick-start': typeof DocsGuidesQuickStartRoute
  '/docs/api/': typeof DocsApiIndexRoute
  '/docs/benchmarks/': typeof DocsBenchmarksIndexRoute
  '/docs/guides/': typeof DocsGuidesIndexRoute
  '/docs/api/array-methods/': typeof DocsApiArrayMethodsIndexRoute
  '/docs/api/builtins/': typeof DocsApiBuiltinsIndexRoute
  '/docs/api/formats/': typeof DocsApiFormatsIndexRoute
  '/docs/api/shortcuts/': typeof DocsApiShortcutsIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/playground': typeof PlaygroundRoute
  '/docs': typeof DocsIndexRoute
  '/docs/guides/installation': typeof DocsGuidesInstallationRoute
  '/docs/guides/interactive-mode': typeof DocsGuidesInteractiveModeRoute
  '/docs/guides/quick-start': typeof DocsGuidesQuickStartRoute
  '/docs/api': typeof DocsApiIndexRoute
  '/docs/benchmarks': typeof DocsBenchmarksIndexRoute
  '/docs/guides': typeof DocsGuidesIndexRoute
  '/docs/api/array-methods': typeof DocsApiArrayMethodsIndexRoute
  '/docs/api/builtins': typeof DocsApiBuiltinsIndexRoute
  '/docs/api/formats': typeof DocsApiFormatsIndexRoute
  '/docs/api/shortcuts': typeof DocsApiShortcutsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/docs': typeof DocsRouteRouteWithChildren
  '/playground': typeof PlaygroundRoute
  '/docs/': typeof DocsIndexRoute
  '/docs/guides/installation': typeof DocsGuidesInstallationRoute
  '/docs/guides/interactive-mode': typeof DocsGuidesInteractiveModeRoute
  '/docs/guides/quick-start': typeof DocsGuidesQuickStartRoute
  '/docs/api/': typeof DocsApiIndexRoute
  '/docs/benchmarks/': typeof DocsBenchmarksIndexRoute
  '/docs/guides/': typeof DocsGuidesIndexRoute
  '/docs/api/array-methods/': typeof DocsApiArrayMethodsIndexRoute
  '/docs/api/builtins/': typeof DocsApiBuiltinsIndexRoute
  '/docs/api/formats/': typeof DocsApiFormatsIndexRoute
  '/docs/api/shortcuts/': typeof DocsApiShortcutsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/docs'
    | '/playground'
    | '/docs/'
    | '/docs/guides/installation'
    | '/docs/guides/interactive-mode'
    | '/docs/guides/quick-start'
    | '/docs/api/'
    | '/docs/benchmarks/'
    | '/docs/guides/'
    | '/docs/api/array-methods/'
    | '/docs/api/builtins/'
    | '/docs/api/formats/'
    | '/docs/api/shortcuts/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/playground'
    | '/docs'
    | '/docs/guides/installation'
    | '/docs/guides/interactive-mode'
    | '/docs/guides/quick-start'
    | '/docs/api'
    | '/docs/benchmarks'
    | '/docs/guides'
    | '/docs/api/array-methods'
    | '/docs/api/builtins'
    | '/docs/api/formats'
    | '/docs/api/shortcuts'
  id:
    | '__root__'
    | '/'
    | '/docs'
    | '/playground'
    | '/docs/'
    | '/docs/guides/installation'
    | '/docs/guides/interactive-mode'
    | '/docs/guides/quick-start'
    | '/docs/api/'
    | '/docs/benchmarks/'
    | '/docs/guides/'
    | '/docs/api/array-methods/'
    | '/docs/api/builtins/'
    | '/docs/api/formats/'
    | '/docs/api/shortcuts/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  DocsRouteRoute: typeof DocsRouteRouteWithChildren
  PlaygroundRoute: typeof PlaygroundRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs': {
      id: '/docs'
      path: '/docs'
      fullPath: '/docs'
      preLoaderRoute: typeof DocsRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/playground': {
      id: '/playground'
      path: '/playground'
      fullPath: '/playground'
      preLoaderRoute: typeof PlaygroundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/docs/': {
      id: '/docs/'
      path: '/'
      fullPath: '/docs/'
      preLoaderRoute: typeof DocsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/api/': {
      id: '/docs/api/'
      path: '/api'
      fullPath: '/docs/api/'
      preLoaderRoute: typeof DocsApiIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/benchmarks/': {
      id: '/docs/benchmarks/'
      path: '/benchmarks'
      fullPath: '/docs/benchmarks/'
      preLoaderRoute: typeof DocsBenchmarksIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/guides/': {
      id: '/docs/guides/'
      path: '/guides'
      fullPath: '/docs/guides/'
      preLoaderRoute: typeof DocsGuidesIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/guides/installation': {
      id: '/docs/guides/installation'
      path: '/guides/installation'
      fullPath: '/docs/guides/installation'
      preLoaderRoute: typeof DocsGuidesInstallationRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/guides/interactive-mode': {
      id: '/docs/guides/interactive-mode'
      path: '/guides/interactive-mode'
      fullPath: '/docs/guides/interactive-mode'
      preLoaderRoute: typeof DocsGuidesInteractiveModeRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/guides/quick-start': {
      id: '/docs/guides/quick-start'
      path: '/guides/quick-start'
      fullPath: '/docs/guides/quick-start'
      preLoaderRoute: typeof DocsGuidesQuickStartRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/api/array-methods/': {
      id: '/docs/api/array-methods/'
      path: '/api/array-methods'
      fullPath: '/docs/api/array-methods/'
      preLoaderRoute: typeof DocsApiArrayMethodsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/api/builtins/': {
      id: '/docs/api/builtins/'
      path: '/api/builtins'
      fullPath: '/docs/api/builtins/'
      preLoaderRoute: typeof DocsApiBuiltinsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/api/formats/': {
      id: '/docs/api/formats/'
      path: '/api/formats'
      fullPath: '/docs/api/formats/'
      preLoaderRoute: typeof DocsApiFormatsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
    '/docs/api/shortcuts/': {
      id: '/docs/api/shortcuts/'
      path: '/api/shortcuts'
      fullPath: '/docs/api/shortcuts/'
      preLoaderRoute: typeof DocsApiShortcutsIndexRouteImport
      parentRoute: typeof DocsRouteRoute
    }
  }
}

interface DocsRouteRouteChildren {
  DocsIndexRoute: typeof DocsIndexRoute
  DocsGuidesInstallationRoute: typeof DocsGuidesInstallationRoute
  DocsGuidesInteractiveModeRoute: typeof DocsGuidesInteractiveModeRoute
  DocsGuidesQuickStartRoute: typeof DocsGuidesQuickStartRoute
  DocsApiIndexRoute: typeof DocsApiIndexRoute
  DocsBenchmarksIndexRoute: typeof DocsBenchmarksIndexRoute
  DocsGuidesIndexRoute: typeof DocsGuidesIndexRoute
  DocsApiArrayMethodsIndexRoute: typeof DocsApiArrayMethodsIndexRoute
  DocsApiBuiltinsIndexRoute: typeof DocsApiBuiltinsIndexRoute
  DocsApiFormatsIndexRoute: typeof DocsApiFormatsIndexRoute
  DocsApiShortcutsIndexRoute: typeof DocsApiShortcutsIndexRoute
}

const DocsRouteRouteChildren: DocsRouteRouteChildren = {
  DocsIndexRoute: DocsIndexRoute,
  DocsGuidesInstallationRoute: DocsGuidesInstallationRoute,
  DocsGuidesInteractiveModeRoute: DocsGuidesInteractiveModeRoute,
  DocsGuidesQuickStartRoute: DocsGuidesQuickStartRoute,
  DocsApiIndexRoute: DocsApiIndexRoute,
  DocsBenchmarksIndexRoute: DocsBenchmarksIndexRoute,
  DocsGuidesIndexRoute: DocsGuidesIndexRoute,
  DocsApiArrayMethodsIndexRoute: DocsApiArrayMethodsIndexRoute,
  DocsApiBuiltinsIndexRoute: DocsApiBuiltinsIndexRoute,
  DocsApiFormatsIndexRoute: DocsApiFormatsIndexRoute,
  DocsApiShortcutsIndexRoute: DocsApiShortcutsIndexRoute,
}

const DocsRouteRouteWithChildren = DocsRouteRoute._addFileChildren(
  DocsRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  DocsRouteRoute: DocsRouteRouteWithChildren,
  PlaygroundRoute: PlaygroundRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
